import { styled } from '../../Styles/stitches.config'

export const StyledContainer = styled('div', {
    m: '0 auto',
    p: '0 $3',
    w: '100%',
})

export const BackgroundContainer = styled('div', {})
